import React from 'react';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/Navbar/Navbar';
import { Check, Users, ClipboardList, Target } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-40 pb-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-slate-200 shadow-sm mb-8">
            <span className="h-2 w-2 rounded-full bg-blue-500"></span>
            <span className="text-sm text-slate-600">Sobre nosotros</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight mb-6">
            Gestión de proyectos
            <br />
            <span className="text-slate-400">clara y eficiente</span>
          </h1>
          
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Ayudamos a equipos a organizar tareas, colaborar mejor y entregar proyectos a tiempo.
          </p>
        </div>
      </section>

      {/* Quiénes somos */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="bg-slate-50 rounded-2xl p-8 md:p-10 border border-slate-200">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Quiénes somos</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              En <span className="font-semibold text-slate-900">CommitFlow</span> somos una plataforma especializada en la gestión estratégica de proyectos. Ayudamos a empresas y equipos a organizar tareas, optimizar recursos y asegurar el cumplimiento de cada compromiso.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Nuestra misión es entregar claridad, eficiencia y trazabilidad, apoyando decisiones basadas en datos y fortaleciendo la productividad de tu organización.
            </p>
          </div>
        </div>
      </section>

      {/* Cómo trabajamos */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">Cómo trabajamos</h2>
            <p className="text-slate-500">Un proceso simple y efectivo</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: <ClipboardList className="w-5 h-5" />,
                step: "01",
                title: "Planificación",
                desc: "Definimos alcance, tareas y responsables con tiempos claros."
              },
              {
                icon: <Users className="w-5 h-5" />,
                step: "02",
                title: "Colaboración",
                desc: "Trabajo en equipo con comunicación y seguimiento en tiempo real."
              },
              {
                icon: <Target className="w-5 h-5" />,
                step: "03",
                title: "Entrega",
                desc: "Revisión ágil y entrega de proyectos con calidad garantizada."
              }
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-xl p-6 border border-slate-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-slate-900 flex items-center justify-center text-white">
                    {item.icon}
                  </div>
                  <span className="text-sm font-mono text-slate-400">{item.step}</span>
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">Nuestros valores</h2>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              "Transparencia en cada proceso",
              "Compromiso con los plazos",
              "Colaboración efectiva",
              "Mejora continua"
            ].map((value, idx) => (
              <div key={idx} className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                  <Check className="w-4 h-4 text-emerald-600" />
                </div>
                <span className="text-slate-700 font-medium">{value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}